import { PermissionsFn } from '~/core/PermissionGuard';

// Exports
export const permissions: PermissionsFn = (context) => {
  if (
    !(
      context.flags.displayLenderSettingsFacilities ||
      context.flags.displayBorrowerSettingsFacilities
    )
  ) {
    return 'deny';
  }
  if (context.flags.isBorrowerLimitedOrganization) return 'upsell';
  return 'allow';
};
